import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { LineChart, Line, XAxis, YAxis,  Tooltip , ResponsiveContainer } from 'recharts';

const Recharts = () => {
  const data = useLoaderData();
  const data1 =data.data 
    return (
        <div className='justify-center ml-10 mt-5  '>
           <h1 className='text-center text-2xl pb-10 '> Dynamic Reachart</h1>
           <ResponsiveContainer height={400} width='70%'>
            <LineChart  data={data1}>
            <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />
            <XAxis dataKey="name" />
            <YAxis dataKey="total" />
            <Tooltip />
            </LineChart>
            </ResponsiveContainer>
            
        </div>
    );
};

export default Recharts;